import { render } from "./SecondComponent.vue?vue&type=template&id=6248d88c&ts=true"
import script from "./SecondComponent.vue?vue&type=script&lang=ts"
export * from "./SecondComponent.vue?vue&type=script&lang=ts"

import "./SecondComponent.vue?vue&type=style&index=0&id=6248d88c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__